/**
 * Module dependencies.
 */

import { theme } from 'src/styles/theme';

/**
 * Export `decadesBackgroundColors`.
 */

export const decadesBackgroundColors = {
  1960: theme.colors.backgrounds.blue02,
  1970: theme.colors.backgrounds.sage02,
  1980: theme.colors.backgrounds.taupe02,
  1990: theme.colors.backgrounds.orange02,
  2000: theme.colors.backgrounds.indigo03,
  2010: theme.colors.backgrounds.teal03,
  2020: theme.colors.backgrounds.yellow03
};
